import React from "react";
import clsx from "clsx";

import styles from "./ClassSelectionCheckbox.module.scss";

type Props = {
  name: string;
  value: string | number;
  label: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const ClassSelectionCheckbox: React.FC<Props> = ({
  name,
  value,
  label,
  checked,
  onChange,
}) => {
  const id = `checkbox-${value}`;

  return (
    <label
      className={clsx(styles.wrapper, checked && styles.checked)}
      htmlFor={id}
    >
      <input
        id={id}
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <div className={styles.box} />
      <div className={styles.label}>{label}</div>
    </label>
  );
};

export default ClassSelectionCheckbox;
